import { Button, Card, Flex, Form, Input, Layout, Typography } from 'antd'
import { useAttemptListener } from 'dev-masters-react-kit'
import { attemptLogin, AuthDTO } from '../../utils/redux/authSlice'
import { listenerMiddleware, useAppDispatch } from '../../utils/redux/store'
import './auth.scss'
import ParticlesBackground from '../../components/ParticlesBackground'
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const { Title } = Typography

export default function SignIn() {
  const [signInForm] = Form.useForm<AuthDTO>()
  const dispatch = useAppDispatch()
  const { t } = useTranslation('common')

  function onFinish(values: AuthDTO) {
    dispatch(attemptLogin(values))
  }

  useAttemptListener({
    listenerMiddleware: listenerMiddleware,
    attempt: attemptLogin,
    onFulfilled: () => {
      console.log('authorized')
    },
  })

  return (
    <>
      <ParticlesBackground />
      <Layout className="auth">
        <Flex flex={1} justify="center" align="center">
          <Card style={{ width: '100%', maxWidth: 400 }}>
            <Title level={3} style={{ textAlign: 'center', marginBottom: 24 }}>
              {t('login')}
            </Title>
            <Form
              form={signInForm}
              onFinish={onFinish}
              className="login"
              layout="vertical"
              initialValues={{
                email: process.env.REACT_APP_DEV_LOGIN,
                password: process.env.REACT_APP_DEV_PASSWORD,
              }}
            >
              <Form.Item
                name="email"
                label={t('email')}
                rules={[
                  { required: true, message: 'Please input your email!' },
                  { type: 'email', message: 'Invalid email, example: user@gmail.com!' },
                ]}
              >
                <Input placeholder={t('email')} />
              </Form.Item>

              <Form.Item
                name="password"
                label={t('password')}
                rules={[{ required: true, message: 'Please input your password!' }]}
              >
                <Input.Password placeholder={t('password')} />
              </Form.Item>
              <Form.Item>
                <Button type="primary" htmlType="submit" block>
                  {t('login')}
                </Button>
              </Form.Item>
              <Flex justify="center">
                <Link to="/register">{t('register')}</Link>
              </Flex>
            </Form>
          </Card>
        </Flex>
      </Layout>
    </>
  )
}
